import { render, staticRenderFns } from "./SharedCPD.vue?vue&type=template&id=577fbe91"
import script from "./SharedCPD.vue?vue&type=script&lang=js"
export * from "./SharedCPD.vue?vue&type=script&lang=js"
import style0 from "./SharedCPD.vue?vue&type=style&index=0&id=577fbe91&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports